import Vue from 'vue';
import RdMessageBoxVue from './RdMessageBox.vue';

const defaults = {
  title: '',
  type: 'primary', // primary 正常 danger 警示类
  message: '',
  iconClass: '',
  checkedModel: false,
  showCloseButton: false,
  showTemporaryChecked: false,
  showAlwaysButton: false,
  dangerouslyUseHTMLString: false,
  showConfirmButton: true,
  showCancelButton: true,
  showMoreDefaultBtn: false,
  showConfirmButtonDropdown: false,
  showDiaryDraftEdit: false,
  diaryDraftEditText: '',
  confirmButtonText: '',
  cancelButtonText: '',
  moreDefaultBtnButtonText: '',
  confirmButtonDropdownList: [],
  confirmButtonDropdownId: 0,
  closeOnClickModal: true,
  closeOnHashChange: true,
  changeHashClose: true,
};

const MessageBoxConstructor = Vue.extend(RdMessageBoxVue);

let instance;
let currentMessage;
let msgQueue = [];

const isVNode = (node) => {
  const { hasOwnProperty } = Object.prototype;
  return node !== null
    && typeof node === 'object'
    && hasOwnProperty.call(node, 'componentOptions');
};

const merge = function (target) {
  // eslint-disable-next-line prefer-rest-params
  const arg = [...arguments];
  for (let i = 1, j = arguments.length; i < j; i++) {
    const source = arg[i] || {};
    Object.keys(source).forEach((prop) => {
      const value = source[prop];
      if (value !== undefined) {
        target[prop] = value;
      }
    });
  }

  return target;
};

function defaultCallback(action) {
  if (!currentMessage) {
    return;
  }
  if (currentMessage.resolve) {
    const actionList = ['clickAlwaysTips', 'moreDefaultBtn', 'showDiaryDraftEdit'];
    if (action === 'confirm') {
      if (instance.showTemporaryChecked || instance.showConfirmButtonDropdown) {
        const p = { action };
        if (instance.showTemporaryChecked) {
          p.value = instance.checkedModel;
        }
        if (instance.showConfirmButtonDropdown) {
          p.confirmButtonDropdownId = instance.confirmButtonDropdownId;
        }
        currentMessage.resolve(p);
      } else {
        currentMessage.resolve({ action });
      }
    } else if (actionList.includes(action)) {
      currentMessage.resolve({ action });
    } else if (currentMessage.reject && (action === 'cancel' || action === 'close')) {
      currentMessage.reject({ action });
    }
  }
}

const initMessage = () => {
  instance = new MessageBoxConstructor({
    el: document.createElement('div'),
  });

  instance.callback = defaultCallback;
};

const showNextMsg = () => {
  if (!instance) {
    initMessage();
  }
  instance.action = '';
  if (instance.visible) {
    return;
  }
  if (msgQueue.length > 0) {
    currentMessage = msgQueue.shift();
    const { options } = currentMessage;
    Object.keys(options).forEach((prop) => {
      instance[prop] = options[prop];
    });
    instance.callback = (action, instanceParams) => {
      defaultCallback(action, instanceParams);
      showNextMsg();
    };
    // 如果是h函数
    if (isVNode(instance.message)) {
      instance.$slots.default = [instance.message];
      instance.message = null;
    } else {
      delete instance.$slots.default;
    }
    ['closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach((prop) => {
      if (instance[prop] === undefined) {
        instance[prop] = true;
      }
    });
    document.body.appendChild(instance.$el);

    Vue.nextTick(() => {
      instance.visible = true;
    });
  }
};

const RdMessageBox = function (options) {
  if (Vue.prototype.$isServer) return;
  if (typeof options === 'string' || isVNode(options)) {
    options = {
      message: options,
    };
  }
  return new Promise((resolve, reject) => { // eslint-disable-line
    msgQueue.push({
      options: merge({}, defaults, RdMessageBox.defaults, options),
      resolve,
      reject,
    });

    showNextMsg();
  });
};

RdMessageBox.close = () => {
  if (instance) {
    instance.doClose();
    instance.visible = false;
  }
  msgQueue = [];
  currentMessage = null;
};

export default RdMessageBox;



// WEBPACK FOOTER //
// ./src/components/messageBox/RdMessageBox.js